Alpine.store('packages', {
    items: [],

    set({ packages }) {
        this.items = packages;
    },

    all() {
        return this.items;
    },
});
